import React, { useMemo, useState, useEffect } from 'react';
import styles from './index.less';
import { JoinClassName } from 'src/utils/utils';
import { useRouter } from 'next/router';
import FrozenRatio from '../../../components/FrozenRatio/FrozenRatio';
import dayjs from 'dayjs';
import ContentfulRichText from '../ContentfulRichText';
import Link from 'next/link';

const PreviewArticleCard = ({ article, showPreview = false, layout = 'horizontal' }) => {
  const router = useRouter();
  let featureImage = article?.fields?.featureImage || null;
  const onPreviewClick = (urlTitle) => {
    // router.push('/blog/article/[article]', `/blog/article/${urlTitle}`);
  };

  return (
    <Link href={`/blog/article/${article.fields.urlTitle}`}>
      <a style={{ display: 'block', color: 'rgba(0, 0, 0, 0.85)', height: '100%' }}>
        <div
          className={JoinClassName(
            styles.articlePreviewCard,
            layout === 'horizontal' ? styles.articlePreviewCardHorizontal : ''
          )}
          onClick={() => onPreviewClick(article.fields.urlTitle)}
        >
          <div className={JoinClassName(styles.articlePreviewCardImage)}>
            {
              <FrozenRatio ratio={layout === 'horizontal' ? 0.8 : 120 / 210}>
                {featureImage && (
                  <img
                    src={featureImage.fields.file.url}
                    alt={featureImage.fields.title}
                    className={JoinClassName(styles.articlePreviewImage)}
                  />
                )}
              </FrozenRatio>
            }
          </div>
          <div className={JoinClassName(styles.articlePreviewCardContent)}>
            <div className={JoinClassName(styles.articlePreviewCardTitle)}>{article.fields.title}</div>
            {article.fields.previewText && (
              <div className={JoinClassName(styles.articlePreviewCardPreview)}>
                {showPreview && <ContentfulRichText document={article.fields.previewText} />}
              </div>
            )}
            <div className={JoinClassName(styles.articlePreviewCardPublishTime)}>
              {article.fields.publishTime ? dayjs(article.fields.publishTime).format('MMMM D, YYYY') : 'unpublished'}
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default PreviewArticleCard;
